<template>
<div class="chapter">
<div class="inner_page">
<div aria-label="1" epub:type="pagebreak" id="page1" role="doc-pagebreak">
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="dedication">To Ernest Pig, Gloucester Old Spot <em class="italic">sans pareil</em>, and to his humans </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// GrandDuchess.vue?fd6f60a0